import { IAdmin, IEnumAdminPermissionKeys } from '@chess-class/sandbox';

export function checkPermission(
  accessCheck: IEnumAdminPermissionKeys,
  accesses?: IAdmin['accesses'],
  edit?: boolean,
): boolean {
  return (!edit && accesses?.[accessCheck] == 'VIEW') || accesses?.[accessCheck] == 'EDIT';
}
